import React, { Component } from 'react'
import { Input, Tabs, Form, Popconfirm, Button } from 'antd'
import styled from 'styled-components'
import RichTextEditor from 'react-rte'
import ContractPaymentSchedules from '../../pages/lead/components/contracts/ContractPaymentSchedules'
import { arrayMove } from '../../util'
import history from '../../history'

const { TextArea } = Input
const TabPane = Tabs.TabPane

const FormLabel = styled.div`
  margin-top: 10px;
`

const MarginTop = styled.div`
  margin-top: 15px;
`

class ContractTemplateForm extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }
  static getDerivedStateFromProps(props, state) {
    if (props.paymentScheduleDataStructure !== state.paymentScheduleDataStructure) {
      return {
        paymentScheduleDataStructure: props.paymentScheduleDataStructure
      }
    }

    // Return null if the state hasn't changed
    return null
  }

  handleCreate = () => {
    const { onCreate } = this.props

    if (onCreate) {
      onCreate(this.state.paymentScheduleDataStructure)
    }
  }

  /* Schedules actions */
  handleAddPaymentSchedule = () => {
    const newPaymentSchedule = this.state.paymentScheduleDataStructure.push({
      percentage: 0,
      description: ''
    })
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedule
    })
  }

  handlePaymentScheduleChange = (value, field, index) => {
    let newPaymentSchedulesDataStructure = this.state.paymentScheduleDataStructure
    if (field === 'description') {
      newPaymentSchedulesDataStructure[index].description = value
    } else {
      newPaymentSchedulesDataStructure[index].percentage = value / 100
    }
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedulesDataStructure
    })
  }

  movePaymentScheduleUp = index => {
    const newPaymentSchedulesDataStructure = arrayMove(
      this.state.paymentScheduleDataStructure,
      index,
      index - 1
    )
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedulesDataStructure
    })
  }

  movePaymentScheduleDown = index => {
    const newPaymentSchedulesDataStructure = arrayMove(
      this.state.paymentScheduleDataStructure,
      index,
      index + 1
    )
    this.setState({
      paymentScheduleDataStructure: newPaymentSchedulesDataStructure
    })
  }

  handleDeletePaymentSchedule = index => {
    const { paymentScheduleDataStructure } = this.state
    let tmpPaymentSchedulesDataStructure = paymentScheduleDataStructure
    tmpPaymentSchedulesDataStructure.splice(index, 1)
    this.setState({
      paymentScheduleDataStructure: tmpPaymentSchedulesDataStructure
    })
  }

  render() {
    const { handleInputChange } = this.props
    return (
      <div>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Details" key="1">
            <Form>
              <div className="row">
                <div className="col-md-12">
                  <div>Template</div>
                  <Input
                    value={this.props.templateName}
                    onChange={event => handleInputChange(event.target.value, 'templateName')}
                  />
                </div>
              </div>
              <div>Description</div>
              <TextArea
                placeholder="Type in description..."
                rows={4}
                onChange={event => handleInputChange(event.target.value, 'templateDescription')}
                value={this.props.templateDescription}
              />
              <FormLabel>Work By Others</FormLabel>
              <RichTextEditor
                value={this.props.workByOthers}
                onChange={event => handleInputChange(event, 'workByOthers')}
              />
              <FormLabel>Terms</FormLabel>
              <RichTextEditor
                value={this.props.terms}
                onChange={event => handleInputChange(event, 'terms')}
              />
              <FormLabel>Header</FormLabel>
              <RichTextEditor
                value={this.props.header}
                onChange={event => handleInputChange(event, 'header')}
              />
              <FormLabel>Footer</FormLabel>
              <RichTextEditor
                value={this.props.footer}
                onChange={event => handleInputChange(event, 'footer')}
              />
            </Form>
          </TabPane>
          <TabPane tab="Schedules" key="2">
            <ContractPaymentSchedules
              paymentScheduleDataStructure={this.state.paymentScheduleDataStructure}
              handleDeletePaymentSchedule={this.handleDeletePaymentSchedule}
              handlePaymentScheduleChange={this.handlePaymentScheduleChange}
              movePaymentScheduleUp={this.movePaymentScheduleUp}
              movePaymentScheduleDown={this.movePaymentScheduleDown}
              handleAddPaymentSchedule={this.handleAddPaymentSchedule}
            />
          </TabPane>
        </Tabs>
        <MarginTop>
          <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.props.confirmDelete}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" icon="delete" className="mr-2">
              Delete
            </Button>
          </Popconfirm>
          <Button type="primary" onClick={() => this.handleCreate()}>
            {this.props.currentId === 0 && <span>Create Template</span>}
            {this.props.currentId > 0 && <span>Save Changes</span>}
          </Button>
        </MarginTop>
      </div>
    )
  }
}

export default ContractTemplateForm



// WEBPACK FOOTER //
// ./src/components/templates/ContractTemplateForm.js